import SFAddNewConnectedAppInstructions from './SFAddNewConnectedAppInstructions'
export default SFAddNewConnectedAppInstructions
